import { ErrorSeverity } from "./ErrorSeverity";
import { Exception } from "./Exception";

export class BadRequestException extends Exception {
  constructor({
    message,
    response = new Response(null, {
      status: 400,
    }),
    stack,
  }: {
    message: string;
    response?: Response;
    stack?: string;
  }) {
    super({
      errorSeverity: ErrorSeverity.ERROR,
      useErrorBoundary: false,
      name: "BadRequestException",
      message,
      response,
      stack,
    });
  }
}
